export default {"src":"/_next/static/media/mock_empty.44811f7b.svg","height":549,"width":976,"blurWidth":0,"blurHeight":0};